import React from 'react'

const Alerts = ({ alerts }) =>
  alerts.map((alert, i) => (
    <Alert
      key={i}
      alert={alert}
    />
  ))

const Alert = ({ alert }) => {
  return (
    <div className="yellow-bordered-content">
      <h4>{alert.name}</h4>
    </div>
  )
}

export default Alerts
